import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaBelow';
const args = {};

export class OligonKentimaBelow extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
